import { FC } from "react";
import {
    Box,
    Flex,
    Heading,
    Icon,
    useBreakpointValue,
} from "@smile2impress/components/relaunch";
import { Icons } from "@smile2impress/components";
import { UniversalImageElement } from "templates/relaunch/primitives/UniversalImageElement";
import { UniversalTextElement } from "templates/relaunch/primitives/UniversalTextElement";

import Link from "components/Link";

import { ColumnProps } from "./Column.types";

export const Column: FC<ColumnProps> = ({
    title,
    text,
    image,
    withSeparator,
    withExpandableText = false,
    numberHeading,
    icon,
    link,
    bg = "base.grey",
    mobileColumn = false,
}) => {
    const isMobile = useBreakpointValue({
        base: true,
        tablet: true,
        desktop: false,
        desktopXL: false,
    });
    const { withFrame = false, withFrameBorders = false } = image || {};
    const iconComponent =
        typeof icon === "string" ? Icons[icon as keyof typeof Icons] : icon;

    return (
        <Flex
            direction="column"
            justifyContent="flex-start"
            w="100%"
            {...(withFrame && isMobile && { bg, p: 2, borderRadius: "sm" })}
            {...(link && {
                as: Link,
                href: link,
                cursor: "pointer",
            })}
        >
            {image && (
                <Box
                    mb={[2]}
                    {...(withFrame &&
                        !isMobile && {
                            bg,
                            p: withFrameBorders ? 2 : 0,
                            borderRadius: "sm",
                            overflow: "hidden",
                        })}
                >
                    <UniversalImageElement {...image} />
                </Box>
            )}
            <Flex
                direction={
                    mobileColumn
                        ? "column"
                        : ["row-reverse", "row-reverse", "column"]
                }
                justifyContent="space-between"
            >
                <Flex>
                    {numberHeading && (
                        <Heading
                            textStyle={["H3"]}
                            color={["text.primary"]}
                            mb={[1, 1, 1]}
                        >
                            {title}
                        </Heading>
                    )}
                    {iconComponent && (
                        <Icon
                            as={iconComponent}
                            w={3}
                            h={3}
                            color="base.bitterSweet"
                            mb={mobileColumn ? [1] : [0, 0, 0.7]}
                        />
                    )}
                </Flex>
                <Flex
                    width="100%"
                    {...(iconComponent &&
                        !mobileColumn && { maxWidth: ["80%", "80%", "100%"] })}
                >
                    <UniversalTextElement
                        title={title}
                        text={text}
                        withSeparator={withSeparator}
                        withExpandableText={withExpandableText}
                        extraTitleStyles={{
                            fontWeight: "medium",
                            mt: [0, 0, 1],
                            textTransform: "uppercase",
                            as: "h3",
                        }}
                    />
                </Flex>
            </Flex>
        </Flex>
    );
};
